import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-upload",
  "use": "icon-upload-usage",
  "viewBox": "0 0 16 11",
  "content": "<symbol viewBox=\"0 0 16 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-upload\">\n<path d=\"M12.3794 4.00628C11.9742 1.80383 10.1688 0.150391 8 0.150391C6.27804 0.150391 4.7825 1.19735 4.03771 2.7295C2.24425 2.93378 0.85 4.56169 0.85 6.53432C0.85 8.6474 2.45279 10.3647 4.425 10.3647H12.1708C13.8153 10.3647 15.15 8.93468 15.15 7.17271C15.15 5.48735 13.9285 4.12119 12.3794 4.00628ZM9.19167 5.89593V8.4495H6.80833V5.89593H5.02083L8 2.70396L10.9792 5.89593H9.19167Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol